/* eslint-disable max-len */
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import I18nLink from 'widgets/I18nLink';

import './FAQSection.css';

class FAQSection extends PureComponent {
  render() {
    const { t } = this.props;

    const groups = [
      [
        {
          title: t('What do I need to rent a vehicle on your website?'),
          description: t('To make a reservation of your scooter, motorcycle or bicycle on BikesBooking.com website you need only credit or debit card. When you will come to the rental company to receive your bike, in order to sign a rental agreement provider may ask for: valid drivers license, ID, some amount of cash or credit/debit card with available funds for deposit. Please check conditions of your provider before booking.')
        },
        {
          title: t('How can I know if my rental bike has an Insurance and what is CDW?'),
          description: t('You don’t pay any commission for our services')
        }
      ],
      [
        {
          title: t('What kind of drivers license I need in order to rent a scooter / ATV / motorbike?'),
          description: t('Conditions of companies are different. In our search results you always can see type of the driving license required by the company. Usually you can rent a scooter with B (car) or A1 driving license. For motorcycle you will need A (moto) driving license. To rent a quad bike (atv) you will need just a car driving license. No license required for bicycles. International drivers permit (IDP) may be requested by the rental company, always check conditions of exact provider.')
        },
        {
          title: t('How can I be sure that rental company will accept my Voucher?'),
          description: t('By making a reservation through BikesBooking.com, you enter into a direct (legally binding) contractual relationship with the bike provider (rental company). Rental company knows about your booking and will provide you with exactly the same bike which you have booked. If the rental company won’t have a bike you have booked, you will receive a better bike without extra charges.')
        }
      ]
    ];

    return (
      <div className="section faq-section">
        <Grid>
          <h2>{t('Frequently Asked Questions')}</h2>

          {groups.map((row, index) => (
            <Row key={index}>
              {row.map((item) => (
                <Col
                  key={item.title}
                  md={6}
                >
                  <div className="faq-item">
                    <h3>{item.title}</h3>

                    <div>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          ))}

          <I18nLink to="/faq/" className="btn btn-link">
            {t('Still have questions')}
          </I18nLink>
        </Grid>
      </div>
    );
  }
}

export default translate(['translation'])(FAQSection);



// WEBPACK FOOTER //
// ./src/components/HomePage/FAQSection/FAQSection.js